import { withDependencies } from '@wix/thunderbolt-ioc'
import { DomReadySymbol, IAppWillMountHandler, ILogger, LoggerSymbol } from '@wix/thunderbolt-symbols'

// TODO check if really necessary or can be set to 'false' for thunderbolt-renderer as well
// https://jira.wixpress.com/browse/PLAT-1893
const validateDefault = process.env.PACKAGE_NAME === 'thunderbolt-renderer'

export const createDomReadyPromise = (validate = validateDefault) =>
	new Promise<void>((resolve) => {
		const verifyAndResolve = () => {
			if (validate) {
				verifyBody()
			}

			resolve()
		}
		if (document.readyState === 'complete' || document.readyState === 'interactive') {
			verifyAndResolve()
		} else {
			document.addEventListener('readystatechange', verifyAndResolve, { once: true })
		}
	})

export const WaitForDomReady = withDependencies<IAppWillMountHandler>(
	[DomReadySymbol, LoggerSymbol],
	(domReady, logger) => ({
		appWillMount: () => domReady.then(() => reportDomReady(logger)),
	})
)

function reportDomReady(logger: ILogger) {
	logger.phaseEnded('dom_ready')
}

function verifyBody(): void {
	const ssrReturnedBody = typeof window.clientSideRender !== 'undefined'
	if (ssrReturnedBody) {
		return
	}

	window.clientSideRender = true
	window.santaRenderingError = window.santaRenderingError || {
		errorInfo: 'body failed to render',
	}

	const pagesCss = window.document.createElement('pages-css')
	pagesCss.setAttribute('id', 'pages-css')
	window.document.body.appendChild(pagesCss)

	const siteContainer = window.document.createElement('DIV')
	siteContainer.setAttribute('id', 'SITE_CONTAINER')
	window.document.body.appendChild(siteContainer)

	window.componentsRegistry?.manifestsLoadedResolve?.()
}
